(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabsComponents = document.querySelectorAll('.tabs-container');
    tabsComponents.forEach(function (component) {
      const tabsLinks = component.querySelectorAll('.tabs-link');

      tabsLinks.forEach(function (link) {
        link.addEventListener('click', function () {
          const targetTab = this.getAttribute('data-tab');
          tabsLinks.forEach((item) => {
            item.classList.remove('active');
          });
          link.classList.add('active');
          const tabContents = component.querySelectorAll('.tab-content');
          tabContents.forEach(function (content) {
            content.classList.remove('active');
          });

          const activeTab = component.querySelector(`#${targetTab}`);
          if (activeTab) {
            activeTab.classList.add('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navimow-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const subscribeForms = document.querySelectorAll(
      '.navimow-banner-subscribe-form',
    );
    const requestJson = function (url, options = {}) {
      const baseUrl = window.baseUrl;
      return fetch(baseUrl + url, {
        headers: {
          'wb-api-key': 'd1befa03c79ca0b84ecc488dea96bc68',
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        ...options,
      }).then((res) => res.json());
    };
    subscribeForms.forEach((form) => {
      form.action = '';
      form.addEventListener('submit', (e) => {
        form.classList.add('loading');
        const submitBtn = form.querySelector('button[type="submit"]');
        submitBtn.disabled = true;

        e.preventDefault();
        const formData = new FormData(form);

        const site = window.site;
        requestJson(
          `/newOfficialWebsite/customer/addCustomerInfo?site=${site}`,
          {
            method: 'POST',
            body: JSON.stringify({
              email: formData.get('contact[email]'),
              tags: `${formData.get('contact[tags]')}`,
              emailMarketingConsent: {
                marketingState: 'SUBSCRIBED',
                marketingOptInLevel: 'SINGLE_OPT_IN',
              },
            }),
          },
        )
          .then((data) => {
            if (data.code === 200) {
              form.classList.add('success');
            } else {
              form.classList.add('error');
            }
            setTimeout(() => {
              form.classList.remove('success');
              form.classList.remove('error');
              form.reset();
            }, 3500);
          })
          .catch((error) => {
            form.classList.add('error');
          })
          .finally(() => {
            form.classList.remove('loading');
            submitBtn.disabled = false;
          });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navimow-carousel-card"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function isHidden(element) {
      if (!element || element.nodeType !== 1) {
        return true;
      }
      return element.offsetWidth === 0 && element.offsetHeight === 0;
    }

    const videoBlocks = document.querySelectorAll(
      '.navimow-carousel-card .video-js',
    );
    const youtubeBlocks = document.querySelectorAll(
      '.navimow-carousel-card youtube-video',
    );

    const playerArray = [];

    videoBlocks.forEach((video, idx) => {
      const player = videojs(video, {});
      playerArray.push(player);
    });

    playerArray.forEach((player) => {
      player.on('fullscreenchange', () => {
        player.controls(player.isFullscreen());
        if (
          !player.isFullscreen() &&
          window.matchMedia('(max-width: 768px)').matches &&
          !player.paused()
        ) {
          setTimeout(() => {
            player.play();
          }, 500);
        }
      });
      const el = player.el();

      if (isHidden(el)) return;

      const parent = el.parentElement;
      const videoPlayPauseBtn = parent.querySelector('.video-play-pause-btn');
      const videoFullscreenBtn = parent.querySelector('.video-fullscreen-btn');

      player.on('play', () => {
        if (videoPlayPauseBtn) {
          videoPlayPauseBtn.classList.add('active');
        }
        playerArray.forEach((item) => {
          if (item !== player) {
            item.pause();
          }
        });
        youtubeBlocks.forEach((item) => {
          item.pause();
        });
      });
      player.on('pause', () => {
        if (videoPlayPauseBtn) {
          videoPlayPauseBtn.classList.remove('active');
        }
      });

      if (videoFullscreenBtn) {
        videoFullscreenBtn.addEventListener('click', () => {
          const videoUrl = window.matchMedia('(max-width: 768px)').matches
            ? videoFullscreenBtn.getAttribute('data-video-url-mb')
            : videoFullscreenBtn.getAttribute('data-video-url');
          if (videoUrl) {
            // Create a fullscreen HTML5 video element and play the URL
            const fullscreenVideo = document.createElement('video');
            fullscreenVideo.src = videoUrl;
            fullscreenVideo.controls = true;
            fullscreenVideo.autoplay = true;
            fullscreenVideo.style.position = 'fixed';
            fullscreenVideo.style.top = 0;
            fullscreenVideo.style.left = 0;
            fullscreenVideo.style.width = '100vw';
            fullscreenVideo.style.height = '100vh';
            fullscreenVideo.style.zIndex = 9999;
            fullscreenVideo.style.backgroundColor = '#000';
            fullscreenVideo.setAttribute('playsinline', '');
            fullscreenVideo.setAttribute('webkit-playsinline', '');

            document.body.appendChild(fullscreenVideo);

            // Fullscreen API
            const requestFullScreen =
              fullscreenVideo.requestFullscreen ||
              fullscreenVideo.webkitRequestFullscreen ||
              fullscreenVideo.mozRequestFullScreen ||
              fullscreenVideo.msRequestFullscreen;

            if (requestFullScreen) {
              requestFullScreen.call(fullscreenVideo);
            }

            // Exit and cleanup when video or fullscreen ends
            const cleanup = () => {
              fullscreenVideo.pause();
              fullscreenVideo.parentNode && fullscreenVideo.parentNode.removeChild(fullscreenVideo);
            };

            fullscreenVideo.addEventListener('fullscreenchange', function () {
              if (!document.fullscreenElement && !document.webkitFullscreenElement) {
                cleanup();
              }
            });
            fullscreenVideo.addEventListener('webkitfullscreenchange', function () {
              if (!document.fullscreenElement && !document.webkitFullscreenElement) {
                cleanup();
              }
            });
            fullscreenVideo.addEventListener('ended', cleanup);
            fullscreenVideo.addEventListener('pause', function () {
              // Also cleanup on pause (optional, remove if not wanted)
              // cleanup();
            });
          }
        });
      }
      if (videoPlayPauseBtn) {
        videoPlayPauseBtn.addEventListener('click', () => {
          if (player.paused()) {
            player.play();
          } else {
            player.pause();
          }
        });
      }
    });

    youtubeBlocks.forEach((youtube, idx) => {
      const videoPlayPauseBtn = youtube.parentElement.querySelector(
        '.video-play-pause-btn',
      );
      if (videoPlayPauseBtn) {
        videoPlayPauseBtn.addEventListener('click', () => {
          youtube.play();
        });
      }

      youtube.addEventListener('video:play', () => {
        youtubeBlocks.forEach((item) => {
          if (item !== youtube) {
            item.pause();
          }
        });
        playerArray.forEach((item) => {
          item.pause();
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
